import React from 'react';

const HeaderLink = ((props)=>(
	<a href={props.url} data-share-url={props.shareUrl} target={props.target} className={props.isActive === true ? props.className+' active' : props.className }>
		{props.text}
		{
			props && props.icon ? <i className={`fa fa-${props.icon}`}></i> :''
		}
	</a>
))

export default HeaderLink


// WEBPACK FOOTER //
// ./src/Components/HeaderLink/index.js